import { render, staticRenderFns } from "./UnitVisitViewPanel.vue?vue&type=template&id=2dd7d8fa&scoped=true"
import script from "./UnitVisitViewPanel.vue?vue&type=script&lang=js"
export * from "./UnitVisitViewPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7d8fa",
  null
  
)

export default component.exports